(function (app) {
    
    app.provider("marketingTrackerRMEApi",
        [
            function () {
                this.$get = [
                    "marketingTrackerApiGateway", function (marketingTrackerApiGateway) {
                        var service = {};

                        service.getRMEContactActivity = function (rmeId) {
                            return marketingTrackerApiGateway.get("/EventGroups/GetResponderEventActivity/" + rmeId);
                        };

                        service.getCustomerCampaigns = function (startDate, endDate) {
                            return marketingTrackerApiGateway.get("/RME/Campaigns?startDate=" + startDate + " +&endDate=" + endDate);
                        };

                        service.getCustomerCampaignEvents = function (campaignId, startDate, endDate) {
                            return marketingTrackerApiGateway.get("/RME/Campaigns/" + campaignId + "/Events?startDate=" + startDate + " +&endDate=" + endDate);
                        };

                        service.getCustomerList = function () {
                            return marketingTrackerApiGateway.get("/RME/Customers");
                        };

                        service.getCustomerRecord = function () {
                            return marketingTrackerApiGateway.get("/RME/Customer/Get");
                        };

                        service.connectCustomerRecord = function (customer) {
                            return marketingTrackerApiGateway.post("/RME/Customer/Connect", customer);
                        };

                        service.removeCustomerRecord = function () {
                            return marketingTrackerApiGateway.delete("/RME/Customer/Remove");
                        };

                        //service.getRMEContactById = function (contactId) {
                        //    return marketingTrackerApiGateway.get("/RME/GetContact/" + contactId);
                        //};

                        return service;
                    }
                ];
            }
        ]);
})(window.app); //jshint ignore:line